import { VOICE_ERROR_CODES } from "../interfaces/VoiceObject";

export const VOICE_CREATION_CODES = {
  FEATURE_DISABLED: VOICE_ERROR_CODES.FEATURE_DISABLED,
  SKILL_DISABLED: VOICE_ERROR_CODES.SKILL_DISABLED,
  NOT_APPLICABLE: "16165",
  INVALID_VALUE: "16163",
  REVISION_CONFLICT: "16133",
  SCHEMA_CHANGED: "16134",
  DRAFT_CLOSED: "16135",
  /** ProductCreationError.IDEMPOTENCY_CONFLICT: creation key already used for another product. */
  CREATION_KEY_USED: "15099",
  DRAFT_LIMIT: "16136",
  MULTIPLE_PRODUCT_SUBJECTS: "16170",
  REQUIRED_FIELD_MISSING: "16171",
  CONTEXT_OVERRIDE_UNRESOLVED: "16172",
  INPUT_FACTS_CONFLICT: "16173",
} as const;

export type KnownVoiceCreationCode =
  (typeof VOICE_CREATION_CODES)[keyof typeof VOICE_CREATION_CODES];
